const BASE_URL = process.env.REACT_APP_API_URL || '';

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchVipData(remoteId) {
  if (!remoteId) return { vip_coin: 0, vip_level: null };
  const url = `${BASE_URL}/api/user/show?remote_id=${encodeURIComponent(remoteId)}`;
  const res = await fetch(url, { headers: { ...authHeaders() } });
  if (!res.ok) throw new Error('Failed to load VIP data');
  const data = await res.json();
  return {
    vip_coin: data.vip_coin ?? 0,
    vip_level: data.vip_level ?? null
  };
}

export async function convertVipCoins(remoteId, amount) {
  if (!remoteId) throw new Error('Missing remote id');
  // Using existing GET endpoint for compatibility. Migrate to POST later.
  const url = `${BASE_URL}/api/convert-vipcoin?remote_id=${encodeURIComponent(remoteId)}&vip_coin=${encodeURIComponent(amount)}`;
  const res = await fetch(url, { headers: { ...authHeaders() } });
  const data = await res.json();
  if (!res.ok || data.status === 'error' || data.message) {
    const message = data.message || data.error || 'Conversion failed';
    const err = new Error(message);
    err.code = data.code || 'API_ERROR';
    throw err;
  }
  // Normalize success structure
  return {
    converted_vip: amount,
    credited_amount: amount, // 1:1 assumption
    remaining_vip: data.remaining_vip !== undefined ? data.remaining_vip : (data.vip_coin ?? 0),
    transaction_id: data.transaction_id || null
  };
}
